import { FlexColumn, Gap } from '../../../ui-components/components/flex';
import { ResponsiveLayout, ResponsiveWidth } from 'ui-components/components/responsive-layout';

import { useShowSellerCommunicationSection } from './hooks/useShowSellerCommunicationSection';
import messages from './messages';
import { SecuritySection } from './sections/security';
import { SellerCommunicationSection } from './sections/seller-communication';
import { SignInSection } from './sections/sign-in';
import style from './style.module.less';
import { SettingsPageTitle } from '../components/settings-page-title/settings-page-title';

export const SignInAndSecurityPage = () => {
  const showSellerCommunicationSection = useShowSellerCommunicationSection();

  return (
    <ResponsiveLayout className={style.signInAndSecurity}>
      <FlexColumn responsiveWidth={ResponsiveWidth.Cols12}>
        <SettingsPageTitle value={messages.signInAndSecurityTitle} />
        <FlexColumn gap={Gap.Space32}>
          <SignInSection />
          {showSellerCommunicationSection ? <SellerCommunicationSection /> : null}
          <SecuritySection />
        </FlexColumn>
      </FlexColumn>
    </ResponsiveLayout>
  );
};
